import { valuePillars } from '../data/valuePillars';
import './ValueProposition.scss';

function ValueProposition() {
  return (
    <section id="value" className="value-proposition">
      <div className="container">
        <span className="section-eyebrow">Value Proposition</span>
        <h2 className="section-title">Too complex for DIY, too focused for big firms</h2>
        <p className="value-proposition__intro">
          Cipher Works is built for the awkward middle: projects that demand rigorous engineering
          but don&apos;t warrant an agency team. I scope engagements for fast iteration while holding to
          production grade quality.
        </p>
        <div className="card-grid value-proposition__grid">
          {valuePillars.map((pillar) => (
            <article key={pillar.title} className="card">
              <h3>{pillar.title}</h3>
              <p>{pillar.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ValueProposition;
